import { PhoneInput } from "react-international-phone"
import styled from "styled-components"

export const StyledPhoneInput = styled(PhoneInput)`
    width: 100%;

    --react-international-phone-height: 44px;

    border-radius: 4px;
`
